import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PaymentOptionList from "../../Components/PaymentOptionList";
import { Form, Button, Modal, Toast } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import "./Cart.scss";
import axios from "../../axios";
import CartItem from "../../Components/CartItem";
import { ShowCheckout, applyTipRequest } from "../../API/CheckoutAPI";
import { useTranslation } from "react-i18next";
import { useQueryClient, useMutation } from "react-query";
import ReactGA from "react-ga4";
import NewLoader from "../../new-components/title/Loader/NewLoader";
import AdditionalItems from "../../Pages/Checkout/AdditionalItems";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import { phoneFormat } from "../../constants/api";
import PhoneInputComponent from "../../Components/PhoneInputComponent";
import Sar from "../../assets/images/icons/Sar";
import ApplePayButton from "../../Components/ApplePayButton";
import useMixpanel from "../../hooks/useMixpanel";

function Cart() {
  const { track } = useMixpanel();
  const [loadingPromo, setLoadingPromo] = useState(false);
  const [code, setCode] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [flowers_delivery_time, setFlowers_delivery_time] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [openMin, setOpenMin] = useState(false);
  const [openAdditional, setOpenAdditional] = useState(false);
  const [is_guest, setIs_guest] = useState(0);
  const [umbrella_room_number, setUmbrella_room_number] = useState("");
  const [family_name, setFamily_name] = useState("");
  const [guestCount, setGuestCount] = useState(""); // guest_count to send to API
  const [isInHouse, setIsInHouse] = useState(null); // is_in_house radio (null/0/1)
  const [isRemoved, setIsRemoved] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState(false);
  const [guestCountError, setGuestCountError] = useState("");
  const [inHouseError, setInHouseError] = useState("");
  const businessType = localStorage.getItem("businessType");

  const [selectedOnlinePaymentMethod, setSelectedOnlinePaymentMethod] =
    useState("credit card");

  const handleCloseMin = () => {
    setOpenMin(false);
  };

  const location = useLocation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const rawPath = location.pathname;
  const { t, i18n } = useTranslation();
  const metadata = location.state?.metadata;
  const currency = localStorage.getItem("currency");

  const [applePaySupported, setApplePaySupported] = useState(false);

  useEffect(() => {
    if (metadata != undefined) {
      toast.error(metadata, {
        position: "bottom-center",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }, []);

  const room_uuid = rawPath.split("/")[1];
  const loaderRef = useRef(null);
  let roomNumber = "";
  let addItemsLink;
  let isUmbrella = 0;
  let cartItems = [];
  // let totalPrice = 0;
  let check;
  let required;
  let methodPaymant = [];
  let resturan_prie = 0;
  let resturan_min_price = 0;
  let flower_prie = 0;
  let flower_min_price = 0;
  let pharmacy_prie = 0;
  let pharmacy_min_price = 0;
  let supermarket_prie = 0;
  let supermarket_min_price = 0;
  let res_name;
  let ph_name;
  let fl_name;
  let su_name;
  let isPharmacy = false;
  let pharmacyId;
  let additional_items = [];
  let order_business;

  let florest_check = false;
  let detailed_address;
  let municipality;
  let tray_charge;
  // let deliveryCharge;
  // let shippingFee;

  let discount;
  let show_checkout_fields;
  let fl_disclaimer;
  let show_tips = false;

  const lang = localStorage.getItem("lang");
  const validated_room_number = localStorage.getItem("validated_room_number");
  console.log("lang*****", lang);

  const { data, isLoading, error } = ShowCheckout(room_uuid, lang);

  if (!isLoading) {
    if (data.data.status === false) {
    } else {
      check = data.data.data;
      if (check?.payment_gateway) {
        localStorage.setItem("payment_gateway", check.payment_gateway);
      }
      console.log("Required fields:", {
        in_house_option_required: check.in_house_option_required,
        guest_count_required: check.guest_count_required,
      });
      show_tips = check.show_tips;
      cartItems = check.order;
      roomNumber = check.roomNumber;
      addItemsLink = check.addItemsLink;
      required = check.required;
      discount = check.discount;
      municipality = check["municipality-tax"];
      tray_charge = check["tray_charge"];
      // deliveryCharge = check.deliveryCharge;
      // shippingFee = check.shippingFee;

      methodPaymant = check.payment_method;
      show_checkout_fields = check.show_checkout_fields;
      detailed_address = check.room.detailed_address;
      isUmbrella = check.room.isUmbrella;
      check?.order.map((item) => {
        if (item.order_type == "restaurant_order") {
          resturan_min_price = item["min-amount"];
          res_name = item.name;
          order_business = item.order_business;
          item?.items.map((it) => {
            resturan_prie = resturan_prie + it?.price;

            if (it?.additional_items.length > 0) {
              additional_items.push(it);
            }
          });
        }
        if (item.order_type == "florist_order") {
          florest_check = true;
          flower_min_price = item["min-amount"];
          fl_name = item.name;
          fl_disclaimer = item?.disclaimer;
          item?.items.map((it) => {
            flower_prie = flower_prie + it?.price;
          });
        }
        if (item.order_type == "pharmacy_order") {
          isPharmacy = true;
          pharmacyId = item?.order_business.id;
          ph_name = item.name;
          pharmacy_min_price = item["min-amount"];
          item?.items.map((it) => {
            pharmacy_prie = pharmacy_prie + it?.price;
          });
        }
        if (item.order_type == "supermarket_order") {
          supermarket_min_price = item["min-amount"];
          su_name = item.name;
          item?.items.map((it) => {
            supermarket_prie = supermarket_prie + it?.price;
          });
        }
      });
      // roomNumber = roomNumber.replace("Room Number ", "");
    }
  }
  const [selected, setSelected] = useState(methodPaymant[0]?.payment_method);
  const [tipAmount, setTipAmount] = useState(0);

  // Track Cart Viewed when data is loaded
  useEffect(() => {
    if (!isLoading && check && cartItems?.length > 0) {
      const totalItems = cartItems.reduce((acc, order) => {
        return (
          acc + (order.items?.length || 0) + (order.combo_meals?.length || 0)
        );
      }, 0);
      track.cartViewed({
        cart_items_count: totalItems,
        cart_total_value: check["total-price"] || 0,
        currency: currency,
      });
    }
  }, [isLoading, check]);

  useEffect(() => {
    if (data?.data?.data?.tips) {
      setTipAmount(Number(data.data.data.tips));
    }
  }, [data]);

  const [order, setOrder] = useState({
    name: "",
    email: "",
    phone: "",
    note: "",
  });

  useEffect(() => {
    if (isUmbrella == 1) {
      setIs_guest(1);
    } else {
      setIs_guest(0);
    }
  }, [isUmbrella]);

  useEffect(() => {
    // Initialize isInHouse to 0 if not required, otherwise keep as null for validation
    if (check && !check.in_house_option_required && isInHouse === null) {
      setIsInHouse(0);
    }
  }, [check, isInHouse]);
  useEffect(() => {
    const hasApplePay =
      typeof window !== "undefined" && window.hasOwnProperty("ApplePaySession");

    console.log("Apple Pay Session", window.ApplePaySession, hasApplePay);
    console.log(hasApplePay, "has apple pay");

    try {
      window.ApplePaySession.canMakePaymentsWithActiveCard(
        "merchant.com.thedigitalhotelier.applepay",
      )
        .then((canMakePaymentsWithActiveCard) => {
          console.log(
            canMakePaymentsWithActiveCard,
            "in here can make payyment",
          );
          setApplePaySupported(canMakePaymentsWithActiveCard);
        })
        .catch((error) => {
          console.error("Error checking Apple Pay capability:", error);
          setApplePaySupported(false);
        });
    } catch (error) {
      console.error("Error checking Apple Pay:", error);
      setApplePaySupported(false);
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setOrder((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [flowers_delivery_timeError, setFlowers_delivery_timeError] =
    useState("");
  const checkValEmail =
    order.email.length >= 0 && !/\S+@\S+\.\S+/.test(order.email);
  const checkInputs = () => {
    console.log("checking inputs");

    const forceRequired = selected == "pay_online";

    if (order.name == "" && (check.name_required || forceRequired)) {
      setName("Name is a required field");
    } else {
      setName("");
    }

    if (florest_check && flowers_delivery_time == "") {
      setFlowers_delivery_timeError(
        "Flowers delivery time is a required field",
      );
    } else {
      setFlowers_delivery_timeError("");
    }

    if (checkValEmail && (forceRequired || check.email_required)) {
      setEmail("The email must be a valid email address.");
    } else {
      setEmail("");
    }

    if (order.phone == "" && (check.phone_required || forceRequired)) {
      setPhone("Phone is a required field");
    } else {
      setPhone("");
    }

    // Validate guest count if required
    if (check.guest_count_required && guestCount === "") {
      setGuestCountError("Guest count is a required field");
    } else {
      setGuestCountError("");
    }

    // Validate in-house option if required
    if (check.in_house_option_required && isInHouse === null) {
      setInHouseError("Please select if you are an in-house guest");
    } else {
      setInHouseError("");
    }
  };

  const isUmbrellaReq = () => {
    let ordered;

    if (selected == "pay_online") {
      ordered = {
        payment_method: selected,
        is_guest: is_guest,
        umbrella_room_number: umbrella_room_number,
        family_name: family_name,
        redirect_url: `https://${window.location.host}/${room_uuid}/CheckoutCallback`,
        guest_count: guestCount ? Number(guestCount) : null,
        is_in_house: isInHouse !== null ? isInHouse : 0,
      };
    } else {
      ordered = {
        payment_method: selected,
        is_guest: is_guest,
        umbrella_room_number: umbrella_room_number,
        family_name: family_name,
        guest_count: guestCount ? Number(guestCount) : null,
        is_in_house: isInHouse !== null ? isInHouse : 0,
      };
    }

    setIsDisabled(true);

    axios
      .post(`/${room_uuid}/orders/checkout`, ordered, {
        headers: {
          lang: lang,
          "Room-Number-From-Dine-in": validated_room_number,
        },
      })
      .then((res) => {
        setIsDisabled(false);
        ReactGA.event({
          category: "Order from checkout page",
          action: "Click",
          value: `type: umbrella_room`,
        });
        // console.log("rsjsskes", res?.data?.data?.payment_url);

        if (res.data.status) {
          // Track Order Submitted
          (res.data.data?.order || []).forEach((orderItem) => {
            track.orderSubmitted({
              order_id: orderItem.id || "",
              order_number: orderItem.unique_order_number || "",
              service_type: "restaurant",
              order_source: localStorage.getItem("room_type") || "room",
              // items_count: (orderItem.items?.length || 0) + (orderItem.combo_meals?.length || 0),
              subtotal: totalPrice - (deliveryCharge || 0),
              tax: 0,
              delivery_fee: deliveryCharge || 0,
              other_fees: 0,
              total_amount: totalPrice,
              is_external_service: false,
            });
          });

          if (res?.data?.data?.payment_url) {
            if (res?.data?.data.is_embedded) {
              setPaymentUrl(res?.data?.data?.payment_url);
            } else {
              window.location.href = res.data.data.payment_url;
            }
            // window.location.replace(res?.data?.data?.payment_url);
          } else {
            navigate(`/${room_uuid}/food-and-beverages/order`, {
              state: { metadata: res.data.data },
            });
          }
        } else if (res.data?.status == false) {
          toast.error(res.data?.message, {
            className: "custom-toast",
            bodyClassName: "custom-toast",
            progressClassName: "custom-toast",
          });
        }
      })
      .catch((err) => {
        setIsDisabled(false);
        console.log(err);
        toast.error("err.message");
      });
  };

  const POSTReq = (type) => {
    let ordered;
    if (type == true) {
      if (selected == "pay_online") {
        ordered = {
          payment_method: selected,
          name: order.name,
          email: order.email,
          phone: order.phone,
          redirect_url: `https://${window.location.host}/${room_uuid}/CheckoutCallback`,
          note: order.note,
          flowers_delivery_time: flowers_delivery_time,
          guest_count: guestCount ? Number(guestCount) : null,
          is_in_house: isInHouse !== null ? isInHouse : 0,
        };
      } else {
        ordered = {
          payment_method: selected,
          name: order.name,
          email: order.email,
          phone: order.phone,
          note: order.note,
          flowers_delivery_time: flowers_delivery_time,
          guest_count: guestCount ? Number(guestCount) : null,
          is_in_house: isInHouse !== null ? isInHouse : 0,
        };
      }
    } else {
      ordered = {
        payment_method: selected,
        flowers_delivery_time: flowers_delivery_time,
      };
      if (order.email != "") {
        ordered.email = order.email;
      }
      if (order.name != "") {
        ordered.name = order.name;
      }
      if (order.phone != "") {
        ordered.phone = order.phone;
      }
      if (order.note != "") {
        ordered.note = order.note;
      }
      ordered.guest_count = guestCount ? Number(guestCount) : null;
      ordered.is_in_house = isInHouse !== null ? isInHouse : 0;
    }
    if (isUmbrella == 1) {
      // is_guest
      ordered.is_guest = is_guest;
    }

    setIsDisabled(true);

    axios
      .post(`/${room_uuid}/orders/checkout`, ordered, {
        headers: {
          lang: lang,
          "Room-Number-From-Dine-in": validated_room_number,
        },
      })
      .then((res) => {
        setIsDisabled(false);
        ReactGA.event({
          category: "Order from checkout page",
          action: "Click",
          value: ``,
        });

        if (res.data.status) {
          // Track Order Submitted
          (res.data.data?.order || []).forEach((orderItem) => {
            track.orderSubmitted({
              order_id: orderItem.id || "",
              order_number: orderItem.unique_order_number || "",
              service_type:
                cartItems?.[0]?.order_type?.replace("_order", "") ||
                "restaurant",
              order_source: localStorage.getItem("room_type") || "room",
              items_count:
                (orderItem.items?.length || 0) +
                (orderItem.combo_meals?.length || 0),
              subtotal: totalPrice - (deliveryCharge || 0),
              tax: 0,
              delivery_fee: deliveryCharge || 0,
              other_fees: 0,
              total_amount: totalPrice,
              is_external_service: false,
            });
          });

          if (res?.data?.data?.payment_url) {
            if (res?.data?.data.is_embedded) {
              setPaymentUrl(res?.data?.data?.payment_url);
            } else {
              window.location.href = res.data.data.payment_url;
            }
            // window.location.replace(res?.data?.data?.payment_url);
          } else {
            navigate(`/${room_uuid}/food-and-beverages/order`, {
              state: { metadata: res.data.data },
            });
          }
        } else if (res.data?.status == false) {
          toast.error(res.data?.message, {
            className: "custom-toast",
            bodyClassName: "custom-toast",
            progressClassName: "custom-toast",
          });
          queryClient.invalidateQueries(`checkout`);
        }
      })
      .catch((err) => {
        setIsDisabled(false);
        toast.error(err.message);
        toast.error("err.message");

        console.log(err);
      });
  };
  const checkPrice = () => {
    if (Number(flower_min_price) > flower_prie) {
      setOpenMin(true);
      return true;
    }
    if (Number(resturan_min_price) > resturan_prie) {
      setOpenMin(true);
      return true;
    }
    if (Number(supermarket_min_price) > supermarket_prie) {
      setOpenMin(true);
      return true;
    }
    if (Number(pharmacy_min_price) > pharmacy_prie) {
      setOpenMin(true);
      return true;
    }
  };
  const checkFlor = florest_check && flowers_delivery_time != "";
  const handleCheckout = async (e) => {
    e.preventDefault();

    // Track Checkout Started
    const totalItems =
      cartItems?.reduce((acc, order) => {
        return (
          acc + (order.items?.length || 0) + (order.combo_meals?.length || 0)
        );
      }, 0) || 0;

    track.checkoutStarted({
      cart_value: totalPrice,
      total_items: totalItems,
      service_type:
        cartItems?.[0]?.order_type?.replace("_order", "") || "restaurant",
    });

    // Track Payment Selected
    track.paymentSelected({
      payment_method: selected || "cash_on_delivery",
      // gateway: selected === "pay_online" ? "telr" : "",
      amount: totalPrice,
    });

    if (isChecked) {
      if (show_checkout_fields == 0) {
        setIsDisabled(true);
        axios
          .post(
            `/${room_uuid}/orders/checkout`,
            {
              note: order.note,
              guest_count: guestCount ? Number(guestCount) : null,
              is_in_house: isInHouse !== null ? isInHouse : 0,
              name: order.name,
            },
            {
              headers: {
                lang: lang,
              },
            },
          )
          .then((res) => {
            setIsDisabled(false);
            ReactGA.event({
              category: "Order from checkout page",
              action: "Click",
              value: ``,
            });
            // console.log("rsjsskes", res?.data?.data?.payment_url);
            if (res.data.status) {
              if (res?.data?.data?.payment_url) {
                if (res?.data?.data.is_embedded) {
                  setPaymentUrl(res?.data?.data?.payment_url);
                } else {
                  window.location.href = res.data.data.payment_url;
                }
                // window.location.replace(res?.data?.data?.payment_url);
              } else {
                navigate(`/${room_uuid}/food-and-beverages/order`, {
                  state: { metadata: res.data.data },
                });
              }
            } else if (res.data?.status == false) {
              toast.error(res.data?.message);
              queryClient.invalidateQueries(`checkout-${lang}`);
            }
          })
          .catch((err) => {
            setIsDisabled(false);
            toast.error(err.message);
            toast.error("err.message");
            console.log(err);
          });
      } else {
        if (!checkPrice()) {
          if (isUmbrella == 1 && is_guest == 1) {
            isUmbrellaReq();
          } else if (
            selected == "pay_online" ||
            check?.name_required ||
            check?.email_required ||
            check?.phone_required ||
            check?.guest_count_required ||
            check?.in_house_option_required
          ) {
            checkInputs();

            const allFieldsFilled =
              order.name != "" &&
              order.phone != "" &&
              !checkValEmail &&
              (!check?.guest_count_required || guestCount !== "") &&
              (!check?.in_house_option_required || isInHouse !== null);

            const requiredFieldsFilled =
              (!check?.email_required || !checkValEmail) &&
              (!check?.name_required || order.name != "") &&
              (!check?.phone_required || order.phone != "") &&
              (!check?.guest_count_required || guestCount !== "") &&
              (!check?.in_house_option_required || isInHouse !== null);

            if (
              (selected === "pay_online" && allFieldsFilled) ||
              (selected !== "pay_online" && requiredFieldsFilled)
            ) {
              if (florest_check) {
                if (flowers_delivery_time != "") {
                  POSTReq(true);
                }
              } else {
                POSTReq(true);
              }
            }
          } else {
            POSTReq(false);
          }
        }
      }
    } else {
      toast.error("Please agree to the terms and conditions", {
        className: "custom-toast",
        bodyClassName: "custom-toast",
        progressClassName: "custom-toast",
      });
    }
  };

  const has_extra_services = localStorage.getItem("has_extra_services");
  const checkout_type = localStorage.getItem("type");
  console.log("has_extra_services", has_extra_services);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  const sendPromoCode = () => {
    setLoadingPromo(true);
    axios
      .post(
        `/${room_uuid}/orders/apply-code`,
        { code },
        { headers: { "Room-Number-From-Dine-in": validated_room_number } },
      )
      .then((res) => {
        console.log("resp", res);
        if (res.data.status) {
          toast.success(res.data.message, {
            className: "custom-toast",
            bodyClassName: "custom-toast",
            progressClassName: "custom-toast",
          });
          queryClient.invalidateQueries(`checkout`);
        } else if (res.data.status == false) {
          toast.error(res.data.message);
        }
        ReactGA.event({
          category: "Send Promo code",
          action: "Click",
          value: `promo code: ${code}`,
        });
        setLoadingPromo(false);
      })
      .catch((err) => {
        console.log("eer", err);
        setLoadingPromo(false);
      });
  };

  console.log("additional_items", additional_items);
  const [issExpress, setIsExpress] = useState(false);
  const [expressLoader, setExpressLoader] = useState(false);

  const handleExpressServices = (e) => {
    if (required) {
      if (order.name != "" && order.email != "" && order.phone != "") {
        setExpressLoader(true);
        axios
          .post(
            `/${room_uuid}/pharmacy/toggle-express`,
            {
              pharmacy_id: pharmacyId,
              express_service: e.target.checked ? 1 : 0,
              name: order.name,
              email: order.email,
              phone: order.phone,
            },
            {
              headers: {
                lang: lang,
              },
            },
          )
          .then((res) => {
            setdeliveryCharge(
              res.data.data.price.deliveryCharge +
                res.data.data.price.shippingFee,
            );
            settotalPrice(res.data.data.price.total);
            // queryClient.invalidateQueries(`checkout`);
            setExpressLoader(false);
          })
          .catch((err) => {
            setExpressLoader(false);
            console.log(err);
          });

        setIsExpress(e.target.checked);
      } else {
        toast.error("Please fill the required fields below", {
          className: "custom-toast",
          bodyClassName: "custom-toast",
          progressClassName: "custom-toast",
        });
      }
    } else {
      axios
        .post(
          `/${room_uuid}/pharmacy/toggle-express`,
          {
            pharmacy_id: pharmacyId,
            express_service: e.target.checked ? 1 : 0,
            name: order.name,
            email: order.email,
            phone: order.phone,
          },
          {
            headers: {
              lang: lang,
            },
          },
        )
        .then((res) => {
          // shippingFee = res.data.data.price.shippingFee
          queryClient.invalidateQueries(`checkout-${lang}`);

          console.log("rsjsskes", res.data.data.price);
        })
        .catch((err) => {
          console.log(err);
        });

      setIsExpress(e.target.checked);
    }
  };

  const [first, serFirst] = useState(true);
  const [deliveryCharge, setdeliveryCharge] = useState(0);
  const [totalPrice, settotalPrice] = useState(0);
  const [selectedTipPct, setSelectedTipPct] = useState(null);
  useEffect(() => {
    if (data && first) {
      setIsExpress(data?.data?.data?.express_service);
      setdeliveryCharge(
        (data?.data?.data?.deliveryCharge == "hidden"
          ? 0
          : data?.data?.data?.deliveryCharge) +
          (data?.data?.data?.shippingFee == "hidden"
            ? 0
            : data?.data?.data?.shippingFee),
      );
      settotalPrice(data.data.data["total-price"]);
      serFirst(true); // check here
    }
  }, [data]);
  useMemo(() => {
    if (selected !== "pay_online") {
      setPaymentUrl("");
    }
  }, [selected]);
  const handleLoad = () => {
    // Hide the loading view when the iframe is loaded
    if (loaderRef.current) {
      loaderRef.current.style.display = "none"; // Hide the loader by setting display to 'none'
      loaderRef.current.style.visibility = "hidden"; // Hide the loader by setting visibility to 'hidden'

      loaderRef.current.remove();
    }
  };

  // Mutation to remove tip (apply 0)
  const removeTipMutation = useMutation(
    ({ uuid }) => applyTipRequest(uuid, 0, "guest"),
    {
      onSuccess: (res) => {
        handleTipApplied(res);
        queryClient.invalidateQueries("checkout");
        queryClient.invalidateQueries(`checkout-${lang}`);
        toast.success(t("Tip removed"), {
          className: "custom-toast",
          bodyClassName: "custom-toast",
          progressClassName: "custom-toast",
        });
      },
      onError: (err) => {
        toast.error(err?.message || t("Failed to remove tip"));
      },
    },
  );

  const RemoveTipButton = () => (
    <button
      type="button"
      onClick={() => removeTipMutation.mutate({ uuid: room_uuid })}
      disabled={removeTipMutation.isLoading}
      className="btn btn-link p-0 ms-2"
      style={{ textDecoration: "underline", fontSize: 12, color: "white" }}
    >
      {removeTipMutation.isLoading ? t("Removing...") : t("Remove tip")}
    </button>
  );

  // Update totals when tip is applied
  const handleTipApplied = (res) => {
    const payload = res?.data ?? res;
    if (payload) {
      const tips = Number(payload?.tips ?? 0);
      setTipAmount(isNaN(tips) ? 0 : tips);
      if (typeof payload["total-price"] !== "undefined") {
        settotalPrice(payload["total-price"]);
      }
      if (!tips) {
        // Clear selected tip percentage when tip is removed
        setSelectedTipPct(null);
      }
    }
  };

  // Local Tip section component
  const TipSection = ({
    room_uuid,
    t,
    onApplied,
    totalPrice,
    tipAmount,
    currency,
    selectedTipPct,
    setSelectedTipPct,
  }) => {
    const queryClient = useQueryClient();
    const [busy, setBusy] = useState(false);
    const [showCustomTip, setShowCustomTip] = useState(false);
    const [customTip, setCustomTip] = useState("");
    const [customTipError, setCustomTipError] = useState("");

    const mutation = useMutation(
      ({ uuid, tip }) => applyTipRequest(uuid, tip, "guest"),
      {
        onMutate: () => setBusy(true),
        onSettled: () => setBusy(false),
        onSuccess: (res) => {
          // Refresh checkout data to update totals
          queryClient.invalidateQueries("checkout");
          queryClient.invalidateQueries(`checkout-${lang}`);
          try {
            onApplied && onApplied(res);
          } catch {}
          toast.success(t("Tip applied"), {
            className: "custom-toast",
            bodyClassName: "custom-toast",
            progressClassName: "custom-toast",
          });
        },
        onError: (err) => {
          toast.error(err?.message || t("Failed to apply tip"));
        },
      },
    );

    const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;
    const handleSelect = (pct) => {
      console.log(pct, "selected tip pct");
      // Compute tip based on current total minus any existing tip
      const base = Math.max(
        0,
        Number(totalPrice || 0) - Number(tipAmount || 0),
      );
      const tipValue = round2((base * Number(pct)) / 100);
      setSelectedTipPct(pct);
      mutation.mutate({ uuid: room_uuid, tip: tipValue });
    };

    const Card = ({ label, value, onClick, active }) => {
      console.log("Rendering Tip Card", { label, value, active });
      return (
        <button
          type="button"
          disabled={busy}
          onClick={onClick}
          className={`tip-card ${active ? "active" : ""}`}
          style={{
            flex: 1,
            border: active
              ? "2px solid var(--color, #f5b431)"
              : "1px solid #ddd",
            color: "white",
            padding: 12,
            borderRadius: 10,
            background: active ? "#262626" : "#000",
          }}
        >
          <div style={{ fontWeight: 600 }}>{label}</div>
          {typeof value !== "undefined" && (
            <div style={{ fontSize: 12, color: "#666" }}>{value}</div>
          )}
        </button>
      );
    };

    const handleOpenCustomTip = () => {
      setCustomTipError("");
      setShowCustomTip(true);
    };

    const handleApplyCustomTip = () => {
      const parsed = Number(customTip);
      if (isNaN(parsed) || parsed < 0) {
        setCustomTipError(t("Please enter a valid amount"));
        toast.error(t("Please enter a valid amount"));
        return;
      }
      // Mark custom as the active selection when applied
      setSelectedTipPct("custom");
      mutation.mutate({ uuid: room_uuid, tip: parsed });
      setShowCustomTip(false);
    };
    return (
      <div className="mb-3">
        <div className="full-heading payment flex" style={{ marginBottom: 8 }}>
          <h2>{t("Add Tip")}</h2>
        </div>
        <div
          style={{
            display: "flex",
            gap: 5,
            marginLeft: "4px",
            marginRight: "4px",
          }}
        >
          <Card
            label="5%"
            value={
              (((totalPrice - tipAmount) * 5) / 100).toFixed(2) + " " + currency
            }
            onClick={() => handleSelect(5)}
            active={selectedTipPct === 5}
          />
          <Card
            label="10%"
            value={
              (((totalPrice - tipAmount) * 10) / 100).toFixed(2) +
              " " +
              currency
            }
            onClick={() => handleSelect(10)}
            active={selectedTipPct === 10}
          />
          <Card
            label="15%"
            value={
              (((totalPrice - tipAmount) * 15) / 100).toFixed(2) +
              " " +
              currency
            }
            onClick={() => handleSelect(15)}
            active={selectedTipPct === 15}
          />
          <Card
            label={t("Custom")}
            onClick={handleOpenCustomTip}
            active={selectedTipPct === "custom"}
          />
        </div>

        <Modal
          show={showCustomTip}
          onHide={() => setShowCustomTip(false)}
          centered
          className="food-modal banner_popup"
        >
          <Modal.Body
            style={{
              padding: 20,
              height: "fit-content  ",
              position: "relative",
            }}
          >
            <button
              type="button"
              aria-label={t("Close")}
              onClick={() => setShowCustomTip(false)}
              style={{
                position: "absolute",
                top: 0,
                right: 10,
                background: "transparent",
                border: "none",
                cursor: "pointer",
                color: "white",
              }}
            >
              <i className="fas fa-close"></i>
            </button>
            <Form.Group className="mb-3 " style={{ marginTop: "30px" }}>
              <Form.Label>{t("Amount")}</Form.Label>
              <Form.Control
                type="number"
                min="0"
                step="0.01"
                value={customTip}
                onChange={(e) => setCustomTip(e.target.value)}
                placeholder={t("Enter tip amount")}
              />
              {customTipError && (
                <span className="err_msg">{customTipError}</span>
              )}
            </Form.Group>
            <div className="d-flex justify-content-end" style={{ gap: 8 }}>
              {/* <Button
                variant="secondary"
                onClick={() => setShowCustomTip(false)}
                disabled={busy}
              >
                {t("Cancel")}
              </Button> */}
              <Button
                className="reg-btn"
                onClick={handleApplyCustomTip}
                disabled={busy}
              >
                {busy ? t("Applying...") : t("Apply")}
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  };

  return (
    <div className="food pb-4">
      <Title title={"Checkout"} />
      <main className=" v2">
        <Toast ref={toast} position="bottom-center" />
        {isLoading ? (
          <NewLoader />
        ) : isRemoved ? (
          <div className="checkout_loader mt-0">
            <div className="loader"></div>
          </div>
        ) : (
          <>
            {cartItems?.map((order) => {
              return order.items.map((item) => {
                return (
                  <CartItem
                    item={item}
                    v2={true}
                    order_type={order.order_type}
                    url_decrease={order.url_decrease}
                    url_increase={order.url_increase}
                    url_remove={order.url_remove}
                    setIsRemoved={setIsRemoved}
                    serFirst={serFirst}
                  />
                );
              });
            })}

            {cartItems?.map((order) => {
              return order?.combo_meals.map((item) => {
                console.log("cartItems", item);
                return (
                  <CartItem
                    item={item}
                    v2={true}
                    order_type={order.order_type}
                    url_decrease={order.url_meal_decrease}
                    url_increase={order.url_meal_increase}
                    url_remove={order.url_meal_remove}
                    setIsRemoved={setIsRemoved}
                    serFirst={serFirst}
                  />
                );
              });
            })}
          </>
        )}

        {/* {cartItems?.length > 0 && addItemsLink != null ? (
          <div className="d-flex justify-content-center mt-2">
            <Link
              to={`/${addItemsLink.replace(
                "/restaurants?b=kit",
                "/restaurant/categories/10"
              )}`}
              className="reg-btn order-btn btn btn-primary"
              onClick={() => {
                ReactGA.event({
                  category: "Click on button Add More Items in checkout page",
                  action: "Click",
                  value: `Add More Items`,
                });
              }}
            >
              {t("Add More Items")}
            </Link>
          </div>
        ) : null} */}
        {show_tips && (
          <TipSection
            room_uuid={room_uuid}
            t={t}
            onApplied={handleTipApplied}
            totalPrice={totalPrice}
            tipAmount={tipAmount}
            currency={currency}
            selectedTipPct={selectedTipPct}
            setSelectedTipPct={setSelectedTipPct}
          />
        )}
        {show_checkout_fields == 1 && (
          <div className="code-parent mb-4">
            <div class="code-section">
              <div class="left">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19.375"
                  height="15.5"
                  viewBox="0 0 19.375 15.5"
                >
                  <path
                    id="Icon_awesome-tags"
                    data-name="Icon awesome-tags"
                    d="M15.074,6.84,8.66.426A1.453,1.453,0,0,0,7.632,0H1.453A1.453,1.453,0,0,0,0,1.453V7.632A1.453,1.453,0,0,0,.426,8.66L6.84,15.074a1.453,1.453,0,0,0,2.055,0L15.074,8.9a1.453,1.453,0,0,0,0-2.055Zm-11.684-2A1.453,1.453,0,1,1,4.844,3.391,1.453,1.453,0,0,1,3.391,4.844ZM18.949,8.9,12.77,15.074a1.453,1.453,0,0,1-2.055,0l-.011-.011,5.269-5.269a2.725,2.725,0,0,0,0-3.853L10.033,0h1.475a1.453,1.453,0,0,1,1.028.426L18.949,6.84a1.453,1.453,0,0,1,0,2.055Z"
                    fill="#006390"
                  ></path>
                </svg>
                <p>{t("Promo Code")}</p>
              </div>
              <div class="middel">
                <input
                  type="text"
                  name="code"
                  onChange={(e) => setCode(e.target.value)}
                />
              </div>
              <div class="right">
                <Button disabled={loadingPromo} onClick={sendPromoCode}>
                  {t("Apply")}{" "}
                </Button>
              </div>
            </div>
          </div>
        )}

        {expressLoader ? (
          <div className="checkout_loader">
            <div className="loader"></div>
          </div>
        ) : (
          <>
            {/* {isPharmacy && (
                <div class="col-12">
                  <div class="mb-3 form-group laundray_check">
                    <input
                      class="accented"
                      type="checkbox"
                      id="is_express"
                      checked={issExpress}
                      name="is_express"
                      onChange={handleExpressServices}
                    />

                    <label class="form-check-label ms-1" for="is_express">
                      Pharmacy instant delivery (within 30 mins)
                    </label>
                  </div>
                </div>
              )} */}

            {discount != "0.0" && (
              <div className="full-heading discount flex m-0 mb-3">
                <h2> {t("Discount")}</h2>
                <h2>
                  {currency === "SAR" ? (
                    <Sar color="currentcolor" />
                  ) : (
                    `${currency} `
                  )}{" "}
                  {discount}
                </h2>
              </div>
            )}
            {deliveryCharge != 0 && (
              <div className="full-heading discount flex m-0 mb-3">
                <h2> {t("Delivery Charge")}</h2>
                <h2>
                  {currency === "SAR" ? (
                    <Sar color="currentcolor" />
                  ) : (
                    `${currency} `
                  )}{" "}
                  {deliveryCharge}
                </h2>
              </div>
            )}

            {municipality != "hidden" && (
              <div className="full-heading discount flex m-0 mb-3">
                <h2> {t("Municipality Tax")}</h2>
                <h2>
                  {currency === "SAR" ? (
                    <Sar color="currentcolor" />
                  ) : (
                    `${currency} `
                  )}{" "}
                  {municipality}
                </h2>
              </div>
            )}
            {tray_charge != "hidden" && (
              <div className="full-heading discount flex m-0 mb-3">
                <h2> {t("Tray Charge")}</h2>
                <h2>
                  {currency === "SAR" ? (
                    <Sar color="currentcolor" />
                  ) : (
                    `${currency} `
                  )}{" "}
                  {tray_charge}
                </h2>
              </div>
            )}

            {tipAmount > 0 && (
              <div
                className="full-heading discount flex m-0 mb-3"
                style={{ alignItems: "center", gap: 8 }}
              >
                <h2> {t("Tip")}</h2>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <RemoveTipButton />
                  <h2>
                    {currency === "SAR" ? (
                      <Sar color="currentcolor" />
                    ) : (
                      `${currency} `
                    )}{" "}
                    {tipAmount}
                  </h2>
                </div>
              </div>
            )}
            {show_checkout_fields == 1 && (
              <div className="full-heading total flex mb-5">
                <h2> {t("Order Total")}</h2>
                <h2>
                  {currency === "SAR" ? (
                    <Sar color="currentcolor" />
                  ) : (
                    `${currency} `
                  )}{" "}
                  {totalPrice}
                </h2>
              </div>
            )}
          </>
        )}

        <Form className="px-3 rounded-form" onSubmit={handleCheckout}>
          {show_checkout_fields == 1 ? (
            <>
              {isUmbrella == 1 ? (
                <div className="guest">
                  <p>{t("Are you a hotel guest?")}</p>
                  <div
                    className="guest_container"
                    style={{ display: "flex", gap: 12, alignItems: "center" }}
                  >
                    <label className="padd-div d-flex align-items-center">
                      <input
                        type="radio"
                        name="is_guest"
                        value="1"
                        checked={is_guest == 1}
                        onChange={() => setIs_guest(1)}
                      />
                      <span className="ms-2">{t("Yes")}</span>
                    </label>
                    <label className="padd-div d-flex align-items-center">
                      <input
                        type="radio"
                        name="is_guest"
                        value="0"
                        checked={is_guest == 0}
                        onChange={() => setIs_guest(0)}
                      />
                      <span className="ms-2">{t("No")}</span>
                    </label>
                  </div>
                </div>
              ) : null}

              {/* Guest count input */}

              {is_guest == 1 && isUmbrella == 1 ? (
                <>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Control
                      type="number"
                      placeholder={t("Room Number")}
                      value={umbrella_room_number}
                      required={is_guest == 1}
                      onChange={(e) => setUmbrella_room_number(e.target.value)}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Control
                      type="text"
                      placeholder={t("Family Name")}
                      value={family_name}
                      required={is_guest == 1}
                      onChange={(e) => setFamily_name(e.target.value)}
                    />
                  </Form.Group>
                </>
              ) : (
                <>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Control
                      type="text"
                      disabled={true}
                      value={roomNumber}
                    />
                  </Form.Group>
                  {detailed_address != null && (
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Control
                        type="text"
                        disabled={true}
                        value={detailed_address}
                        // placeholder="Enter Your Room # (Optional)"
                      />
                    </Form.Group>
                  )}
                  {businessType !== "Meeting Room" && (
                    <Form.Group className="mb-3" controlId="formBasicname">
                      <Form.Control
                        type="text"
                        placeholder={t(
                          `Your Name ${
                            selected == "pay_online" ||
                            check.name_required == true
                              ? ""
                              : "(Optional)"
                          }`,
                        )}
                        name="name"
                        value={order.name}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  )}
                  {name && <span className="err_msg"> {t(`${name}`)}</span>}

                  <Form.Group className="mb-3" controlId="formBasicname">
                    <Form.Control
                      type="emial"
                      placeholder={t(
                        `Your Email ${
                          selected == "pay_online" ||
                          check.email_required == true
                            ? ""
                            : "(Optional)"
                        }`,
                      )}
                      name="email"
                      value={order.email}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                  {email && <span className="err_msg">{t(`${email}`)} </span>}

                  {/*    <Form.Group className="mb-3" controlId="formBasicname">
              <Form.Select
                className="form-control"
                aria-label="Default select example"
              >
                <option>Date & Time</option>
              </Form.Select>
            </Form.Group> */}

                  <Form.Group className="mb-3 w-100">
                    <PhoneInputComponent
                      value={order.phone}
                      onChange={(phone) => {
                        setOrder((prev) => ({
                          ...prev,
                          phone,
                        }));
                      }}
                    />
                  </Form.Group>
                  {phone && <span className="err_msg">{t(`${phone}`)} </span>}
                  {florest_check && (
                    <>
                      <Form.Group className="mb-3" controlId="formBasicname">
                        <select
                          className="form-control"
                          placeholder=""
                          // required={true}
                          value={flowers_delivery_time}
                          onChange={(e) => {
                            setFlowers_delivery_time(e.target.value);
                            ReactGA.event({
                              category:
                                "Select Flowers_delivery_time in checkout page",
                              action: "Click",
                              value: `value: ${e.target.value}`,
                            });
                          }}
                        >
                          <option value="">Flowers Delivery Time</option>
                          <option value="10:00 AM - 12:00 PM">
                            10:00 AM - 12:00 PM
                          </option>
                          <option value="12:00 PM - 02:00 PM">
                            12:00 PM - 02:00 PM
                          </option>
                          <option value="02:00 PM - 04:00 PM">
                            02:00 PM - 04:00 PM
                          </option>
                          <option value="04:00 PM - 06:00 PM">
                            04:00 PM - 06:00 PM
                          </option>
                        </select>
                      </Form.Group>
                      {flowers_delivery_timeError && (
                        <span className="err_msg">
                          {t(`${flowers_delivery_timeError}`)}
                        </span>
                      )}
                    </>
                  )}
                  {businessType !== "Meeting Room" && (
                    <Form.Group className="mb-3" controlId="formBasicname">
                      <Form.Control
                        type="text"
                        placeholder={t("Note/Special Request (Optional)")}
                        name="note"
                        value={order.note}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                  )}
                  {/* Add Tip section */}

                  {checkout_type === "in_dining" && (
                    <>
                      <Form.Group className="mb-3" controlId="formBasicname">
                        <Form.Control
                          type="number"
                          min="0"
                          placeholder={t(
                            check?.guest_count_required
                              ? "Guest Count"
                              : "Guest Count (Optional)",
                          )}
                          value={guestCount}
                          onChange={(e) => setGuestCount(e.target.value)}
                        />
                      </Form.Group>
                      {guestCountError && (
                        <span className="err_msg">
                          {t(`${guestCountError}`)}
                        </span>
                      )}
                    </>
                  )}

                  {/* is_in_house radio */}
                  {checkout_type === "in_dining" && (
                    <>
                      <div
                        className="d-flex align-items-center mb-3"
                        style={{ gap: 12 }}
                      >
                        <div className="me-2">
                          {t(
                            check?.in_house_option_required
                              ? "In House Guest"
                              : "In House Guest (Optional)",
                          )}
                        </div>
                        <label className="padd-div d-flex align-items-center">
                          <input
                            type="radio"
                            name="is_in_house"
                            value="1"
                            checked={isInHouse === 1}
                            onChange={() => setIsInHouse(1)}
                          />
                          <span className="ms-2">{t("Yes")}</span>
                        </label>
                        <label className="padd-div d-flex align-items-center">
                          <input
                            type="radio"
                            name="is_in_house"
                            value="0"
                            checked={isInHouse === 0}
                            onChange={() => setIsInHouse(0)}
                          />
                          <span className="ms-2">{t("No")}</span>
                        </label>
                      </div>
                      {inHouseError && (
                        <span className="err_msg">{t(`${inHouseError}`)}</span>
                      )}
                    </>
                  )}
                </>
              )}

              {methodPaymant?.length > 0 && (
                <div className="full-heading payment flex">
                  <h2>{t("Payment Options")}</h2>
                </div>
              )}
              <PaymentOptionList
                selected={selected}
                setSelected={setSelected}
                methods={methodPaymant}
              />

              {/* 
selected === "pay_online" &&
                applePaySupported &&
                check.apple_pay_available */}
              {selected === "pay_online" &&
                applePaySupported &&
                check.apple_pay_available && (
                  <>
                    <div className="online-payment notransition">
                      <a
                        className={
                          selectedOnlinePaymentMethod === "credit card" &&
                          "active"
                        }
                        onClick={() =>
                          setSelectedOnlinePaymentMethod("credit card")
                        }
                      >
                        Credit Card
                      </a>

                      <a
                        className={
                          selectedOnlinePaymentMethod === "pay with apple" &&
                          "active"
                        }
                        onClick={() =>
                          setSelectedOnlinePaymentMethod("pay with apple")
                        }
                      >
                        Apple Pay
                      </a>
                    </div>
                  </>
                )}
              <div
                className="padd-div d-flex agree my-4"
                style={{ position: "relative" }}
              >
                <div className="terms-underline-theme" />
                <input
                  type="checkbox"
                  checked={isChecked}
                  onClick={() => {
                    setIsChecked((prev) => !prev);
                    ReactGA.event({
                      category: "click on checkbox in checkout page ",
                      action: "Click",
                      value: `I agree to Terms & Conditions: ${isChecked}`,
                    });
                  }}
                />
                <a
                  href="https://thedigitalhotelier.com/guest-journey-terms-and-conditions/"
                  target="_blank"
                >
                  {/* {t("I agree to Terms & Conditions")} */}
                  {t("I agree to")}{" "}
                  <span
                    style={{
                      textDecoration: "underline",
                      textDecorationColor: "#f5b431",
                    }}
                  >
                    {t("terms and conditions")}
                  </span>
                </a>
              </div>
            </>
          ) : (
            <>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Control
                  type="text"
                  disabled={true}
                  value={`${roomNumber}`}
                />
              </Form.Group>
              {businessType !== "Meeting Room" && (
                <Form.Group className="mb-3" controlId="formBasicname">
                  <Form.Control
                    type="text"
                    placeholder={t(`Your Name (Optional) `)}
                    name="name"
                    value={order.name}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              )}
              {businessType !== "Meeting Room" && (
                <Form.Group className="mb-3" controlId="formBasicname">
                  <Form.Control
                    type="text"
                    placeholder={t("Note/Special Request (Optional)")}
                    name="note"
                    value={order.note}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              )}
              {/* Add Tip section (compact form) */}
              <TipSection
                room_uuid={room_uuid}
                t={t}
                onApplied={handleTipApplied}
                totalPrice={totalPrice}
                tipAmount={tipAmount}
                currency={currency}
                selectedTipPct={selectedTipPct}
                setSelectedTipPct={setSelectedTipPct}
              />
            </>
          )}

          {!paymentUrl && selectedOnlinePaymentMethod === "credit card" ? (
            <div className="padd-div text-center">
              <Button
                type="button"
                onClick={handleCheckout}
                className="reg-btn order-btn"
                // onClick={}
                disabled={isDisabled || cartItems.length == 0}
                // to="/RestaurantOrderPlaced"
              >
                {t("Order")}
              </Button>
            </div>
          ) : selectedOnlinePaymentMethod === "pay with apple" ? (
            <ApplePayButton
              amount={totalPrice}
              currencyCode="AED"
              countryCode="AE"
              merchantIdentifier="merchant.com.thedigitalhotelier.applepay"
              merchantName="Digital Hotelier Software Solutions L.L.C"
              roomId={room_uuid}
              payment_method={selected}
              is_guest={is_guest}
              umbrella_room_number={umbrella_room_number}
              family_name={family_name}
              guest_count={guestCount ? Number(guestCount) : 0}
              is_in_house={isInHouse}
              isDisabled={isDisabled}
              setIsDisabled={setIsDisabled}
              order={order}
              email={email}
              phone={phone}
              username={name}
              checkInputs={checkInputs}
              checked={isChecked}
              checkPrice={checkPrice}
            />
          ) : null}
          {fl_disclaimer && (
            <div
              className="mx-3 text-center"
              dangerouslySetInnerHTML={{
                __html: fl_disclaimer,
              }}
            />
          )}

          {selected === "pay_online" && paymentUrl && (
            <div className="payment-iframe">
              <div
                className="d-flex justify-content-center m-5 "
                ref={loaderRef}
              >
                {/* <div className="home_loader"> */}
                <div
                  className="loader"
                  style={{
                    borderColor: "lightgray",
                    borderRightColor: "#000000",
                  }}
                ></div>
                {/* </div>sss */}
              </div>
              <iframe
                loading="lazy"
                src={paymentUrl}
                width="100%"
                title="Payment Preview"
                scrolling="no"
                onLoad={handleLoad}
              ></iframe>
            </div>
          )}
        </Form>

        {/* <div className="spacer-40 my-5"></div> */}
      </main>
      <NewFooter />
      <AdditionalItems
        setOpenAdditional={setOpenAdditional}
        openAdditional={openAdditional}
        additional_items={additional_items}
        order_business={order_business}
        theme={true}
        settotalPrice={settotalPrice}
      />
      <Modal
        show={openMin}
        onHide={handleCloseMin}
        className={` `}
        style={{ minHeight: "150px", height: "auto" }}
      >
        <Modal.Body
          style={{
            padding: "20px",
            height: "auto",
          }}
        >
          {resturan_min_price > resturan_prie && (
            <>
              <p className=" ">
                {`${t("To proceed with you order for")} ${res_name} ${t(
                  "you need to reach the amount of",
                )} ${currency} ${resturan_min_price} ${t(
                  "and you already have",
                )} ${currency} ${resturan_prie}`}
              </p>
              <Link
                to={`/${room_uuid}/restaurant/categories/10`}
                className="reg-btn check_m"
              >
                Go to restaurant
              </Link>
              <hr />
            </>
          )}

          {flower_min_price > flower_prie && (
            <>
              <p className=" ">
                {`${t("To proceed with you order for")} ${fl_name} ${t(
                  "you need to reach the amount of",
                )} ${currency} ${flower_min_price} ${t(
                  "and you already have",
                )} ${currency} ${flower_prie}`}
              </p>
              <Link to={`/${room_uuid}/florists`} className="reg-btn check_m ">
                {t("Go to florist")}
              </Link>
              <hr />
            </>
          )}
          {pharmacy_min_price > pharmacy_prie && (
            <>
              <p className=" ">
                {`${t("To proceed with you order for")} ${ph_name} ${t(
                  "you need to reach the amount of",
                )} ${currency} ${pharmacy_min_price} ${t(
                  "and you already have",
                )} ${currency} ${pharmacy_prie}`}
              </p>
              <Link to={`/${room_uuid}/pharmacies`} className="reg-btn check_m">
                {t("Go to pharmacy")}
              </Link>
              <hr />
            </>
          )}

          {supermarket_min_price > supermarket_prie && (
            <>
              <p className=" ">
                {`${t("To proceed with you order for")} ${su_name} ${t(
                  "you need to reach the amount of",
                )} ${currency} ${supermarket_min_price} ${t(
                  "and you already have",
                )} ${currency} ${supermarket_prie}`}
              </p>
              <Link
                to={`/${room_uuid}/supermarkets`}
                className="reg-btn check_m"
              >
                {t("Go to subermarket")}
              </Link>
              <hr />
            </>
          )}
          <div>
            <Button
              onClick={handleCloseMin}
              className="reg-btn v2 service"
              style={{
                textAlign: "center",
                padding: "8.5px 15px !important",
              }}
            >
              {t(`OK`)}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default Cart;
